import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    activeCompanies:null,
    activeBank:null,
};

export const companySlice = createSlice({
    initialState,
    name: 'companySlice',
    reducers: {
        setActiveCompanies: (state, { payload }) => {
            state.activeCompanies = payload
        },
        setActiveBank: (state, { payload }) => {
            state.activeBank = payload
        }
    },
});

export default companySlice.reducer;

export const { setActiveCompanies, setActiveBank } = companySlice.actions;